export default __webpack_public_path__ + "files/1f419.fb1ebe4a0ba630d4181b5b4f94716891.png";